import { ErrorNotice } from '../../components/ErrorNotice';
import type { PolicyProblem } from './shared';

/**
 * A refused Auto-approval write — CLM-108. The CLM-109 `FieldSetProblemNotice`
 * precedent: a refusal the API names is this banner, in the page's own words,
 * never `ErrorNotice`'s copy for its kind — that copy is written for other
 * surfaces (a `conflict` there is verify-field's "Another reviewer settled this
 * field"; a `validation` says the page has a defect). A 409 is neutral (`up`,
 * `role=status`): nothing failed, the state moved. A 400 or 404 is `bad`.
 *
 * Anything else — a 403 (a caller who is not Scope-All, or lacks the action), a
 * 5xx, a code this build has no words for — is still `ErrorNotice`, by kind.
 * The correlation id is always shown.
 */
export function PolicyProblemNotice({ problem }: { readonly problem: PolicyProblem }) {
  const { refusal } = problem;
  if (refusal === null) return <ErrorNotice kind={problem.kind} correlation_id={problem.correlation_id} />;
  return (
    <div
      className={`banner ${refusal.tone}`}
      role={refusal.tone === 'bad' ? 'alert' : 'status'}
      data-testid="policy-refusal"
      data-code={refusal.code}
    >
      <p className="notice-head">
        <strong>{refusal.head}</strong>
      </p>
      <p>{refusal.body}</p>
      {problem.correlation_id === null || problem.correlation_id === '' ? null : (
        <p className="mut">
          Correlation id <code>{problem.correlation_id}</code>
        </p>
      )}
    </div>
  );
}
